import { Grid, GridProps } from "@mui/material";
import classNames from "classnames";
import React, { FC } from "react";

import "./ViewPort.scss";

interface IViewPortProps extends GridProps {
	"data-testid": string;
	fullWidth?: boolean;
	fullHeight?: boolean;
}

const ViewPort: FC<IViewPortProps> = ({
	children,
	className,
	"data-testid": dataTestId,
	fullWidth = false,
	fullHeight = true,
	...props
}) => {
	let columns = props.columns;

	if (!columns && props.container) {
		columns = { xs: 1, sm: 2, md: 4, lg: 12, xl: 12 };
	}

	return (
		<Grid
			{...props}
			className={classNames(
				"ViewPort",
				{ "ViewPort--fullWidth": fullWidth, "ViewPort--fullHeight": fullHeight },
				className
			)}
			data-testid={dataTestId}
			columns={columns}
		>
			{children}
		</Grid>
	);
};

export default ViewPort;
